// src/pages/paymentCallback.js
// PhonePe redirects to: /payment/callback/:orderId after payment attempt

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { verifyPayment, resetPayment } from '../store/slices/paymentSlice';
import { fetchCart } from '../store/slices/cartSlice';
import { setError, setSuccess } from '../store/slices/uiSlice';
import Loader from '../components/common/loader';

const PaymentCallback = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'failed'

  useEffect(() => {
    verifyWithBackend();
  }, [orderId]);

  const verifyWithBackend = async () => {
    try {
      setStatus('verifying'); 
      // await dispatch(verifyPayment({ orderId })).unwrap();

      // console.log('🔍 Verifying payment for orderId:', orderId);
    const result = await dispatch(verifyPayment({ orderId })).unwrap();
    // console.log('✅ Verify result:', result);

      dispatch(setSuccess('Payment successful! Your order is being processed.'));
      try {
        await dispatch(fetchCart()).unwrap();
      } catch (_) {}

      setStatus('success');
      setTimeout(() => {
        navigate(`/order-success/${orderId}`, { replace: true });
      }, 1500);
    } catch (err) {
      // console.error('Payment verification failed:', err);
      setStatus('failed');
       const msg = err?.message || 'Payment verification failed.';
dispatch(setError(msg));    
}
  };

  if (status === 'verifying') {
    return (
      <div className="container mx-auto px-4 py-8 flex justify-center items-center min-h-screen">
        <div className="text-center">
          <Loader size="lg" />
          <h2 className="text-xl font-semibold mt-6 mb-2">Verifying your payment...</h2>
          <p className="text-gray-500 text-sm">Please do not close or refresh this page.</p>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div className="container mx-auto px-4 py-8 flex justify-center items-center min-h-screen">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
            <svg className="w-8 h-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2 className="text-2xl font-semibold mb-2 text-green-700">Payment Successful!</h2>
          <p className="text-gray-500 text-sm">Redirecting to your order...</p>
          <Loader size="sm" className="mt-3" />
        </div>
      </div>
    );
  }

  // Failed
  return (
    <div className="container mx-auto px-4 py-8 flex justify-center items-center min-h-screen">
      <div className="text-center max-w-md">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
          <svg className="w-8 h-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h2 className="text-2xl font-semibold mb-2 text-red-700">Payment Failed</h2>
        <p className="text-gray-600 mb-2 text-sm">
          Your payment could not be verified. If money was deducted from your account, it will be refunded automatically within 5–7 business days.
        </p>
        <p className="text-gray-500 text-xs mb-6">
          For support, email us at <span className="font-medium">klmkartsales@gmail.com</span> with your Order ID: <span className="font-medium">{orderId}</span>
        </p>
        <div className="flex flex-col gap-3">
          <button
            className="w-full bg-purple-600 text-white py-2 rounded-lg font-medium hover:bg-purple-700 transition"
            onClick={verifyWithBackend}
          >
            Retry Verification
          </button>
          <button
            className="w-full border border-gray-300 text-gray-700 py-2 rounded-lg text-sm hover:bg-gray-50 transition"
            onClick={() => navigate('/orders')}
          >
            View My Orders
          </button>
          <button
            className="text-purple-600 hover:underline text-sm"
            onClick={() => navigate('/checkout', { replace: true })}
          >
            ← Back to Checkout
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCallback;